import {useState} from "react";
import {notification} from "antd";
import {AppRadioGroup} from "shared/UI/UIKit/Radio";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppButton} from "shared/UI/UIKit/Button";
import type {RadioChangeEvent} from "antd";
import type {Question} from "../../../../../config/types";

type SingleQuestionProps = {
  question: Question;
}

export const SingleQuestion = (props: SingleQuestionProps) => {
  const [error, setError] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [value, setValue] = useState();

  const options = props.question.variants.map(item => {
    return {
      label: item.text,
      value: item.id
    };
  });

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  const checkAnswer = () => {
    setDirty(true);
    if (props.question.answer[0] === value) {
      setError(false);
      notification.success({
        message: "Вы ответили верно",
        duration: 2,
      });
    } else {
      setError(true);
      notification.error({
        message: "Вы ответили неверно",
        duration: 2,
      });
    }
  };

  const getType = () => {
    if (dirty && error) {
      return "danger";
    }

    if (dirty && !error) {
      return "success";
    }
  };

  return (
    <AppFlex alignItems="flex-start" unit="30">
      <AppText type={getType()} size={24} weight={700}>{props.question.text}</AppText>
      <AppRadioGroup value={value} direction="vertical"
                     options={options} onChange={onChange}/>
      <AppButton onClick={checkAnswer} disabled={!value}>
        Проверить
      </AppButton>
    </AppFlex>
  );
};